import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { useLang } from "@/common/Contexts/LanguageContext";
import { PageNamesEnum } from "@/routes/routes";
import stl from "./SeoLandingDetailPage.module.css";
var SeoLandingDetailPage = function SeoLandingDetailPage() {
  var lang = useLang();
  var page = useFullPageData(PageNamesEnum.PAGE_NAME__SeoLandingDetail);
  if (!page) return null;
  var content = lang === "en" ? page.content_en : page.content_ar;
  var dir = lang === "en" ? "ltr" : "rtl";
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    linksForSearch: true,
    authenticationMsg: true
  }, page.css && /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: page.css
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper,
    dir: dir,
    style: {
      direction: dir
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.content,
    dangerouslySetInnerHTML: {
      __html: content
    }
  })), page.js && /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: page.js
    }
  }));
};
export default SeoLandingDetailPage;